(function(){
  if(window.__flHome)return;window.__flHome=true;
  var ls={get:function(k){try{return localStorage.getItem(k)}catch(e){return null}},set:function(k,v){try{localStorage.setItem(k,v)}catch(e){}}};
  var toastEl,toastT;
  function toast(html){
    if(!toastEl){toastEl=document.createElement('div');toastEl.className='fl-toast';toastEl.setAttribute('role','status');document.body.appendChild(toastEl)}
    toastEl.innerHTML=html;toastEl.classList.add('is-on');clearTimeout(toastT);toastT=setTimeout(function(){toastEl.classList.remove('is-on')},3200);
  }
  window.flToast=toast;
  function esc(t){return String(t==null?'':t).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function egp(c){return 'EGP '+Math.round(Number(c||0)/100).toLocaleString('en-US')}
  function sized(u,w){if(!u)return '';u=String(u);if(u.indexOf('//')===0)u='https:'+u;return u+(u.indexOf('?')>-1?'&':'?')+'width='+w}
  var TICK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  /* the + turns into a tick for a moment after adding */
  function added(b){
    if(!b)return;b.classList.add('is-added');
    var svg=b.querySelector('svg');
    if(svg&&!b.__orig){b.__orig=b.innerHTML;b.innerHTML=TICK}
    clearTimeout(b.__t);b.__t=setTimeout(function(){b.classList.remove('is-added');if(b.__orig){b.innerHTML=b.__orig;b.__orig=null}},1800);
  }
  function addedToast(name,img){
    toast((img?'<img src="'+esc(img)+'" alt="" width="30" height="30">':'')+'<span><b>Added</b>'+(name?' · '+esc(name):'')+'</span><a href="/cart">View bag</a>');
  }
  function cardImg(b){var c=b&&b.closest&&b.closest('.fl-card,.fl-wadd,.fl-sx__row,[data-fl-item]');var i=c&&c.querySelector('img');return i?(i.currentSrc||i.src):''}
  function addToBag(id){
    return fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
      .then(function(r){return r.json().then(function(j){return{ok:r.ok,j:j}})});
  }
  /* quick add: one-size products go straight in, products with shades or sizes open the picker */
  document.addEventListener('click',function(e){
    var k=e.target.closest&&e.target.closest('[data-fl-pick]');
    if(k){e.preventDefault();e.stopPropagation();openPicker(k);return}
    var b=e.target.closest&&e.target.closest('[data-fl-add]');
    if(!b)return;
    e.preventDefault();e.stopPropagation();
    if(b.classList.contains('is-busy'))return;
    b.classList.add('is-busy');
    addToBag(b.getAttribute('data-fl-add')).then(function(res){
        b.classList.remove('is-busy');
        if(res.ok){added(b);addedToast(b.getAttribute('data-fl-title')||'',cardImg(b))}
        else{toast((res.j&&res.j.description)||'Sorry, that one just sold out')}
      }).catch(function(){b.classList.remove('is-busy');toast('Something went wrong, try again')});
  },true);
  /* start loading the product as soon as she touches the + */
  document.addEventListener('pointerdown',function(e){var k=e.target.closest&&e.target.closest('[data-fl-pick]');if(k)loadProduct(k.getAttribute('data-fl-pick'))},{passive:true,capture:true});

  /* shade / size picker */
  var cache={},pk,pkState=null,lastTrigger=null;
  function loadProduct(h){
    if(!h)return Promise.reject();
    if(!cache[h])cache[h]=fetch('/products/'+encodeURIComponent(h)+'.js',{credentials:'same-origin',headers:{'Accept':'application/json'}}).then(function(r){if(!r.ok)throw 0;return r.json()}).catch(function(err){delete cache[h];throw err});
    return cache[h];
  }
  function isShade(n){n=String(n||'').toLowerCase();return /shade|colou?r|tone|teint/.test(n)}
  function shadeCol(v){return window.flShadeCol?window.flShadeCol(v):null}
  function buildPicker(){
    pk=document.createElement('div');pk.className='fl-pk';pk.setAttribute('aria-hidden','true');
    pk.innerHTML='<div class="fl-pk__dim" data-pk-close></div><div class="fl-pk__box" role="dialog" aria-modal="true" aria-label="Choose an option"><div class="fl-pk__grab" aria-hidden="true"></div><div class="fl-pk__hd"><span class="fl-pk__img" data-pk-img></span><div class="fl-pk__b"><span class="fl-pk__v" data-pk-v></span><span class="fl-pk__t" data-pk-t></span><span class="fl-pk__p" data-pk-p></span></div><button type="button" class="fl-pk__x" data-pk-close aria-label="Close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div><div data-pk-opts><p class="fl-pk__load">Loading shades…</p></div><button type="button" class="fl-pk__go" data-pk-go disabled>Add to bag</button><a class="fl-pk__more" data-pk-more href="#">See full details</a></div>';
    document.body.appendChild(pk);
    pk.addEventListener('click',function(e){
      if(e.target.closest('[data-pk-close]')){closePicker();return}
      var o=e.target.closest('[data-pk-val]');if(o){choose(Number(o.getAttribute('data-pk-i')),o.getAttribute('data-pk-val'));return}
      if(e.target.closest('[data-pk-go]'))goAdd();
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&pk.classList.contains('is-open'))closePicker()});
  }
  function openPicker(k){
    if(!pk)buildPicker();
    lastTrigger=k;var h=k.getAttribute('data-fl-pick'),card=k.closest('.fl-card,.fl-wadd,.fl-sx__row,[data-fl-item]');
    var vEl=card&&card.querySelector('.fl-card__vendor,.fl-wadd__v,.fl-sx__v'),img=cardImg(k);
    pk.querySelector('[data-pk-v]').textContent=vEl?vEl.textContent.trim():'';
    pk.querySelector('[data-pk-t]').textContent=k.getAttribute('data-fl-title')||'';
    pk.querySelector('[data-pk-p]').innerHTML='';
    pk.querySelector('[data-pk-img]').innerHTML=img?'<img src="'+esc(img)+'" alt="">':'';
    pk.querySelector('[data-pk-opts]').innerHTML='<p class="fl-pk__load">Loading…</p>';
    var go=pk.querySelector('[data-pk-go]');go.disabled=true;go.textContent='Add to bag';
    pk.querySelector('[data-pk-more]').href='/products/'+h;
    pkState=null;
    pk.classList.add('is-open');pk.setAttribute('aria-hidden','false');document.documentElement.classList.add('fl-lock');
    requestAnimationFrame(function(){pk.classList.add('is-on')});
    setTimeout(function(){var x=pk.querySelector('.fl-pk__x');if(x)x.focus({preventScroll:true})},60);
    loadProduct(h).then(function(p){if(lastTrigger!==k)return;render(p,k)}).catch(function(){location.href='/products/'+h});
  }
  function closePicker(){
    if(!pk)return;pk.classList.remove('is-on');document.documentElement.classList.remove('fl-lock');
    setTimeout(function(){pk.classList.remove('is-open');pk.setAttribute('aria-hidden','true')},260);
    if(lastTrigger&&lastTrigger.focus)try{lastTrigger.focus({preventScroll:true})}catch(e){}
  }
  function render(p,k){
    var opts=(p.options||[]).map(function(o,i){return typeof o==='string'?{name:o,values:uniq(p.variants.map(function(v){return v.options[i]}))}:o});
    var first=null;for(var i=0;i<p.variants.length;i++){if(p.variants[i].available){first=p.variants[i];break}}
    first=first||p.variants[0];
    pkState={p:p,opts:opts,sel:first.options.slice(),k:k};
    var html='';
    opts.forEach(function(o,i){
      if(!o.values||o.values.length<2)return;
      var shade=isShade(o.name),mode='pill';
      if(shade){
        var imgs=o.values.map(function(val){var v=p.variants.filter(function(x){return x.options[i]===val&&x.featured_image})[0];return v?v.featured_image.src:null});
        var distinct=uniq(imgs.filter(Boolean)).length===o.values.length;
        var cols=o.values.map(shadeCol);
        if(cols.every(Boolean))mode='col';else if(distinct)mode='img';
        o._imgs=imgs;o._cols=cols;
      }
      o._mode=mode;
      var label=o.name.charAt(0).toUpperCase()+o.name.slice(1).toLowerCase();
      if(shade)label='Shade';
      html+='<div class="fl-pk__opt" data-pk-opt="'+i+'"><div class="fl-pk__lab"><span><span class="fl-pk__on">'+esc(label)+':</span> <b data-pk-sel="'+i+'"></b></span><span>'+o.values.length+' '+(shade?'shades':'options')+'</span></div><div class="'+(mode==='pill'?'fl-pk__pills':'fl-pk__sw fl-pk__sw--'+mode)+'" role="group" aria-label="'+esc(label)+'">';
      o.values.forEach(function(val,j){
        var a=' data-pk-i="'+i+'" data-pk-val="'+esc(val)+'" aria-label="'+esc(val)+'" title="'+esc(val)+'"';
        if(mode==='col')html+='<button type="button" class="fl-pk__s"'+a+' style="background:'+o._cols[j]+'"></button>';
        else if(mode==='img')html+='<button type="button" class="fl-pk__s fl-pk__s--img"'+a+'><img src="'+esc(sized(o._imgs[j],120))+'" alt="" loading="lazy"></button>';
        else html+='<button type="button" class="fl-pk__pill"'+a+'>'+esc(val)+'</button>';
      });
      html+='</div></div>';
    });
    pk.querySelector('[data-pk-opts]').innerHTML=html||'';
    sync();
  }
  function uniq(a){var o=[];a.forEach(function(x){if(o.indexOf(x)<0)o.push(x)});return o}
  function match(sel){var vs=pkState.p.variants;for(var i=0;i<vs.length;i++){var ok=true;for(var j=0;j<sel.length;j++){if(vs[i].options[j]!==sel[j]){ok=false;break}}if(ok)return vs[i]}return null}
  function choose(i,val){
    var s=pkState.sel.slice();s[i]=val;
    var v=match(s);
    if(!v||!v.available){var alt=pkState.p.variants.filter(function(x){return x.options[i]===val&&x.available})[0];if(alt)s=alt.options.slice()}
    pkState.sel=s;sync();
  }
  function sync(){
    var st=pkState,v=match(st.sel),p=st.p;
    st.opts.forEach(function(o,i){
      var lab=pk.querySelector('[data-pk-sel="'+i+'"]');if(lab)lab.textContent=st.sel[i];
      pk.querySelectorAll('[data-pk-i="'+i+'"]').forEach(function(b){
        var val=b.getAttribute('data-pk-val'),t=st.sel.slice();t[i]=val;var m=match(t);
        var anyAvail=p.variants.some(function(x){return x.options[i]===val&&x.available});
        b.classList.toggle('is-out',!(m&&m.available)&&!anyAvail);
        b.setAttribute('aria-pressed',val===st.sel[i]?'true':'false');
      });
    });
    var pr=pk.querySelector('[data-pk-p]'),go=pk.querySelector('[data-pk-go]');
    if(v){
      var sale=v.compare_at_price&&v.compare_at_price>v.price;
      pr.className='fl-pk__p'+(sale?' is-sale':'');
      pr.innerHTML=egp(v.price)+(sale?'<s>'+egp(v.compare_at_price)+'</s>':'');
      var img=v.featured_image&&v.featured_image.src;if(img){pk.querySelector('[data-pk-img]').innerHTML='<img src="'+esc(sized(img,200))+'" alt="">'}
      pk.querySelector('[data-pk-more]').href=p.url+(p.url.indexOf('?')>-1?'&':'?')+'variant='+v.id;
    }
    if(v&&v.available){go.disabled=false;go.textContent='Add to bag · '+egp(v.price)}
    else{go.disabled=true;go.textContent=v?'Sold out':'Not available'}
  }
  function goAdd(){
    var st=pkState;if(!st)return;var v=match(st.sel);if(!v||!v.available)return;
    var go=pk.querySelector('[data-pk-go]');if(go.classList.contains('is-busy'))return;go.classList.add('is-busy');go.textContent='Adding…';
    addToBag(v.id).then(function(res){
      go.classList.remove('is-busy');
      if(res.ok){
        var name=(st.k.getAttribute('data-fl-title')||st.p.title),opts=st.opts.filter(function(o){return o.values&&o.values.length>1}).map(function(o){return st.sel[st.opts.indexOf(o)]});
        var img=v.featured_image&&v.featured_image.src?sized(v.featured_image.src,120):cardImg(st.k);
        closePicker();added(st.k);addedToast(name+(opts.length?' in '+opts.join(' / '):''),img);
      }else{sync();toast(esc((res.j&&res.j.description)||'Sorry, that one just sold out'))}
    }).catch(function(){go.classList.remove('is-busy');sync();toast('Something went wrong, try again')});
  }
  window.flPicker={open:openPicker,load:loadProduct};
  /* mood switch */
  function initMood(root){
    if(root.__fl)return;root.__fl=1;
    var btns=root.querySelectorAll('[data-mood]'),panels=root.querySelectorAll('[data-panel]');
    function set(m,save){
      btns.forEach(function(x){x.setAttribute('aria-selected',x.getAttribute('data-mood')===m?'true':'false')});
      panels.forEach(function(p){p.hidden=p.getAttribute('data-panel')!==m});
      root.setAttribute('data-active',m);
      if(save){if(window.flMood)window.flMood.set(m);else ls.set('fl-mood',m);root.querySelectorAll('[data-welcome]').forEach(function(w){w.hidden=true})}
    }
    btns.forEach(function(x){x.addEventListener('click',function(){set(x.getAttribute('data-mood'),true)})});
    var saved=window.flMood?window.flMood.get():ls.get('fl-mood');
    if(saved==='fery'||saved==='lola'){
      set(saved,false);
      if(window.flMood&&window.flMood.returning()){var w=root.querySelector('[data-welcome="'+saved+'"]');if(w)w.hidden=false}
    }
  }
  /* tabs */
  function initTabs(root){
    if(root.__fl)return;root.__fl=1;
    var tabs=root.querySelectorAll('[data-tab]'),panes=root.querySelectorAll('[data-pane]');
    tabs.forEach(function(t){t.addEventListener('click',function(){
      var k=t.getAttribute('data-tab');
      tabs.forEach(function(x){x.setAttribute('aria-selected',x===t?'true':'false')});
      panes.forEach(function(p){p.hidden=p.getAttribute('data-pane')!==k});
    })});
  }
  /* carousel dots + autoplay */
  function initCarousel(root){
    if(root.__fl)return;root.__fl=1;
    var track=root.querySelector('[data-track]'),dots=root.querySelectorAll('[data-dot]');
    if(!track)return;var slides=track.children;if(slides.length<2)return;
    var idx=0,timer,touched=false,delay=(Number(root.getAttribute('data-autoplay'))||0)*1000;
    function go(i){var s=slides[i];if(!s)return;track.scrollTo({left:s.offsetLeft-track.offsetLeft-parseInt(getComputedStyle(track).paddingLeft||0),behavior:'smooth'})}
    function mark(){var best=0,bd=1e9;for(var i=0;i<slides.length;i++){var d=Math.abs(slides[i].getBoundingClientRect().left-track.getBoundingClientRect().left-16);if(d<bd){bd=d;best=i}}idx=best;dots.forEach(function(d,i){d.classList.toggle('is-active',i===idx);d.setAttribute('aria-current',i===idx?'true':'false')})}
    var raf;track.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(mark)},{passive:true});
    dots.forEach(function(d,i){d.addEventListener('click',function(){touched=true;go(i)})});
    ['touchstart','pointerdown','wheel'].forEach(function(ev){track.addEventListener(ev,function(){touched=true},{passive:true})});
    if(delay){timer=setInterval(function(){if(touched||document.hidden)return;go((idx+1)%slides.length)},delay)}
    mark();
  }
  /* dismiss */
  function initDismiss(root){
    if(root.__fl)return;root.__fl=1;
    var key='fl-dismiss-'+root.getAttribute('data-fl-dismiss');
    if(ls.get(key)){root.hidden=true;return}
    var x=root.querySelector('[data-close]');if(x)x.addEventListener('click',function(){root.hidden=true;ls.set(key,'1')});
  }
  function init(){
    document.querySelectorAll('[data-fl-mood]').forEach(initMood);
    document.querySelectorAll('[data-fl-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-fl-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-fl-dismiss]').forEach(initDismiss);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
